import * as React from "react";
import { Typography, Box, AppBar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import NotificationDrawer from "./NotificationDrawer";
import ProfileAvatar from "../../../utils/ProfileAvatar";
import { useLocation } from "react-router-dom";
import { getHealthCheck } from "../../../actions/auth";
import { getReferenceData } from "../../../actions/company";
import { getCompressedSessionItem } from "../../../utils/compressedSessionStorage";
export default function Apper() {
  const dispatch = useDispatch();
  const [notificationDrawer, setNotificationDrawer] = React.useState(false);

  const toggleNotificationDrawer = () => {
    setNotificationDrawer(!notificationDrawer);
  };
  const authUserData = JSON.parse(sessionStorage.getItem("user"));
  const companyName = authUserData?.company?.name;
  const location = useLocation();
  const referenceData = getCompressedSessionItem("referenceData");
  const { isAuthenticated, isConsentAccepted } = useSelector(
    (store) => store.auth
  );
  React.useEffect(() => {
    dispatch(getHealthCheck());
  }, []);

  React.useEffect(() => {
    if (isAuthenticated && isConsentAccepted && !referenceData) {
      dispatch(getReferenceData());
    }
  }, [isAuthenticated, isConsentAccepted, referenceData]);

  const isApplicationIncludesInUrl =
    location?.pathname.includes("/application");
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          background: !isApplicationIncludesInUrl ? "#F2F1F8" : "#fff",
          boxShadow: "21px 21px 40px rgba(0, 0, 0, 0.05)",
          maxWidth: "2000px",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        {" "}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            p: 0.5,
            alignItems: "center",
          }}
        >
          {" "}
          <Typography
            component="h1"
            variant="h6"
            color="#000"
            sx={{ mt: 0.5, mr: 2 }}
          >
            {" "}
            {companyName}{" "}
          </Typography>{" "}
          {/* <IconButton
            color="black"
            onClick={toggleNotificationDrawer}
            sx={{ mr: 2, width: "50px" }}
          >
            <Badge
              variant={
                notificationCount && notificationCount.unread !== 0 ? "dot" : ""
              }
              color="error"
            >
              <Notification />
            </Badge>
          </IconButton> */}
          <Typography component="div" sx={{ mr: 2 }}>
            {" "}
            <ProfileAvatar />{" "}
          </Typography>{" "}
        </Box>{" "}
        <NotificationDrawer
          drawerState={notificationDrawer}
          toggleNotificationDrawer={toggleNotificationDrawer}
        />{" "}
      </AppBar>{" "}
    </Box>
  );
}
